import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

import { LegacyCallToActionWithLanguage } from './legacy-call-to-action-with-language';

const LegacyCallToActionWithLanguageWithCustomValidation = ({
  validationProps, updateValidation, setNewCTACallback, onChange: onChangeFromProps, ...restProps
}) => {
  const { data } = validationProps;

  const activity = useContext(ActivityContext);
  const onChange = useCallback((updates, extraParameters) => {
    updateValidation([], { CallToAction: updates });
    onChangeFromProps(extraParameters);

    if (activity) {
      activity.signal(`onLegacyCallToActionWithLanguageChange - ${JSON.stringify(updates)}`);
    }
  }, [updateValidation, onChangeFromProps, activity]);

  return (
    <LegacyCallToActionWithLanguage value={data} setNewCTACallback={setNewCTACallback} onChange={onChange} {...restProps} />
  );
};

LegacyCallToActionWithLanguageWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      CallToAction: PropTypes.string,
      CallToActionLanguage: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  setNewCTACallback: PropTypes.func,
};

LegacyCallToActionWithLanguageWithCustomValidation.defaultProps = {
  onChange: () => {},
  setNewCTACallback: null,
};

export const ValidatedLegacyCallToActionWithLanguage = withCustomValidation(LegacyCallToActionWithLanguageWithCustomValidation);
